import React, { useEffect, useState } from "react";
import { useUserBranches } from "../../../hooks/accessControl";
import { Typography } from "antd";
import { useIntl } from "react-intl";
const { Text, Title } = Typography;

const BranchItem = (props) => {
  const { name, record } = props;
  const intl = useIntl();
  const [branchName, setBranchName] = useState("");
  const userBranches = useUserBranches();

  useEffect(() => {
    const branch = userBranches.filter((i) => i.id === record.branch)[0];
    if (branch) {
      setBranchName(branch.name);
    }
  }, [record.branch, userBranches]);

  return (
    <div className="details_item">
      <Text ellipsis>
        {intl.formatMessage({
          id: `app.forms.patient.${name}`,
        })}
      </Text>
      <Title level={5} ellipsis>
        {branchName}
      </Title>
    </div>
  );
};

export default BranchItem;
